import { RainGaugeDTO } from '@/api/raingauges/dto/RainGaugeDTO'
import { RainGauge } from '@/model/RainGauge'

export class RainGaugeFactory {
  static fromDTO(rainGaugeDTOs: Array<RainGaugeDTO>): Array<RainGauge> {
    return rainGaugeDTOs.map(
      (dto) =>
        new RainGauge(
          dto.id,
          dto.name,
          dto.station_type,
          [dto.geolocation.latitude, dto.geolocation.longitude],
          dto.rainfall,
        ),
    )
  }
}
